import React, {useEffect, useState, useRef} from 'react';
import {useRecoilState} from 'recoil';

import FilterModalHeader from '../FilterModal/FilterModalHeader';
import {CommunityCategory} from '../../../store';

interface Props {
  isOpen: boolean;
  togglePopup: (is: boolean) => void;
}

export interface CategoryItemType {
  txt: Category;
  param: CategoryParam;
}

export default function CategoryModal({isOpen, togglePopup}: Props) {
  const [toggledCategory, setToggledCategory] = useState<CategoryItemType>();
  const [selectedCategory, setSelectedCategory] =
    useRecoilState(CommunityCategory);

  const categories: CategoryItemType[] = [
    {
      txt: 'Special',
      param: 'special',
    },
    {
      txt: 'Family',
      param: 'family',
    },
    {
      txt: 'Refresh',
      param: 'refresh',
    },
    {
      txt: 'Eco-friendly',
      param: 'eco_friendly',
    },
    {
      txt: 'Pet-friendly',
      param: 'pet_friendly',
    },
    {
      txt: 'Healthy',
      param: 'healthy',
    },
    {
      txt: 'Drinking',
      param: 'drinking',
    },
    {
      txt: 'Daily',
      param: 'daily',
    },
  ];

  const complete = () => {
    if (toggledCategory) {
      setSelectedCategory(toggledCategory);
      togglePopup(false);
    }
  };

  const initCategory = () => {
    setToggledCategory(selectedCategory);
  };
  const close = () => {
    initCategory();
    togglePopup(false);
  };
  const initFn = () => {
    setSelectedCategory(undefined);
    setToggledCategory(undefined);
    togglePopup(false);
  };

  const wrapperRef = useRef<HTMLDivElement>(null);
  useEffect(() => {
    document.addEventListener('mousedown', handleClickOutside);

    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  });

  const handleClickOutside = (event: any) => {
    if (wrapperRef && !wrapperRef?.current?.contains(event.target)) {
      togglePopup(false);
    }
  };

  return (
    <div className="modal-wrapper" style={{display: isOpen ? 'flex' : 'none'}}>
      <div
        className={`modal-contents category ${isOpen ? 'active' : 'none'}`}
        ref={wrapperRef}>
        <FilterModalHeader
          txt={'카테고리 선택'}
          close={() => close()}
          hasInit={true}
          fnTxt="초기화"
          initFn={() => initFn()}
        />
        <ul className="category-modal-body">
          {categories.map(category => {
            return (
              <li
                className={`${
                  toggledCategory && toggledCategory.txt === category.txt
                    ? 'active'
                    : ''
                }`}
                key={`modal-category-${category.txt}`}
                onClick={() => setToggledCategory(category)}>
                {category.txt}
              </li>
            );
          })}
        </ul>
        <div className="filter-modal-footer">
          <button
            className="modal btn black-filled"
            disabled={!toggledCategory}
            onClick={() => complete()}
            style={{background: !toggledCategory ? '#E9E7EC' : '#000'}}>
            선택 완료
          </button>
          <button className="modal btn empty" onClick={() => close()}>
            취소
          </button>
        </div>
      </div>
    </div>
  );
}
